import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-button-edit-copy-renderer',
  template: `
  <style>
  .row-action-btns {
    min-width: 70px;
  }
  .row-action-btns .mat-icon-button:not(:last-child) {
    margin-right: 10px;
  }
  .row-action-btns .mat-icon-button.edit-btn {
      background: #3aafe4;
  }
  .row-action-btns .mat-icon-button {
      width: 34px;
      height: 34px;
      line-height: 34px;
      border-radius: 10px;
      visibility: visible;
      transition: all .4s;
      top:5px
  }
  .mat-button-wrapper{
    padding: 0;
  }
  </style>
    <div class="row-action-btns">
      <button (click)="onClick($event, 'edit')" mat-mini-fab class="mat-focus-indicator mat-mini-fab mat-button-base mat-primary" style="background-color: blue;">
        <span><i class="fa fa-pencil" style="color: #fff;"></i></span>
        <span matripple class="mat-ripple mat-button-ripple mat-button-ripple-round"></span>
        <span class="mat-button-focus-overlay"></span>
      </button>
      <button (click)="onClick($event, 'copyform')" mat-mini-fab class="mat-focus-indicator mat-mini-fab mat-button-base mat-primary" style="background-color: orange; margin-left: 5px;">
        <span><i class="fa fa-copy" style="color: #fff;"></i></span>
        <span matripple class="mat-ripple mat-button-ripple mat-button-ripple-round"></span>
        <span class="mat-button-focus-overlay"></span>
      </button>
    </div>
  `
})
export class ButtonEditCopyRendererComponent implements ICellRendererAngularComp {

  params: any;
  label!: string;

  agInit(params: any): void {
    this.params = params;
    this.label = this.params.label || null;
  }

  refresh(params?: any): boolean {
    return true;
  }

  onClick($event: any, action: string) {
    if (this.params.onClick instanceof Function) {
      // Pass action type and other necessary params to the parent component
      const params = {
        event: $event,
        action: action,  // Pass action type
        rowData: this.params.node.data
      };
      this.params.onClick(params);
    }
  }
}
